function isText(element) {
  return !("type" in element) && "text" in element && typeof element.text === "string";
}
function isPlainText(node) {
  return isText(node) && Object.keys(node).length === 1;
}

export { isPlainText, isText };
//# sourceMappingURL=is-text.js.map
